<template>
    <!-- 考生组管理 -->
    <div>
        <el-card class="fatherCard">
            <div slot="header">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item>
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>考生组管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <el-tabs v-model="activeName"  class="elTab" @tab-click="backToManagerExamineeGroup()">
                    <el-tab-pane label="考生组管理" name="first"  >
                        <div v-show="!modifyFlag" class="list_container">                  
                            <div class="search_container" >
                                <div>
                                    <el-input v-model="groupQueryParams.groupName" placeholder="考生组关键词" class="impoWorldInput"></el-input>
                                    <el-button type="primary" @click="queryGroupInfos()">查询</el-button>
                                </div>
                                <el-button type="danger" @click="deleteSelectedGroups()" class="searchButton">批量删除</el-button>
                                
                            </div> 
                            <el-table :data="groupList" max-height="600px" stripe highlight-current-row 
                                        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
                                        ref="multipleTable" @selection-change="selectedGroupChange"> 
                                        <el-table-column  type="selection" width="55"></el-table-column> 
                                <el-table-column label="序号" align="center" type="index" width="50px" ></el-table-column>      
                                <el-table-column prop="groupName" label="考生组名称"   align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="groupId" label="考生组ID"  v-if="false"></el-table-column>
                                <el-table-column  label="组内人数"  align="center">
                                    <template slot-scope="scope">{{scope.row.users.length}}</template>
                                </el-table-column>                         
                                <el-table-column prop="createBy" label="创建者"  align="center"> </el-table-column>
                                <el-table-column prop="createTime" label="创建时间"  align="center" sortable> 
                                    <template slot-scope="scope">{{dateFormatter(scope.row.createTime)}}</template>
                                </el-table-column>
                                <el-table-column label="最后修改时间" align="center"> 
                                    <template slot-scope="scope">{{dateFormatter(scope.row.updateTime)}}</template>
                                </el-table-column>
                                <el-table-column  label="考生组状态"  align="center">
                                    <template slot="header" >
                                        <div class="switchDiv">
                                            <span>考生组状态</span>
                                            <el-switch v-model="switchValue"  active-color="#13ce66"  inactive-color="#909399"></el-switch>
                                        </div>
                                    </template>
                                    <template slot-scope="scope">{{ scope.row.state === '0' ? '禁用' : '在用' }}</template>
                                </el-table-column>
                                <!-- <el-table-column prop="updateBy" label="最后修改者" width="150" align="center"> </el-table-column> -->
                                <el-table-column  label="操作"   align="center">
                                    <template slot-scope="scope">
                                        <el-button @click="previewExamineeGroup(scope.row)" type="success" size="mini">预览</el-button>
                                        <el-button @click="modifyExamineeGroup(scope.row)" type="primary" size="mini">修改</el-button>
                                        <el-button @click="modifyState(scope.row)" :type="switchValue === true ? 'danger' : 'success'" size="mini">{{switchValue === true ? '禁用' : '启用'}}</el-button>
                                    </template>
                            </el-table-column>
                            </el-table>         
                            <el-pagination @size-change="groupTableSizeChange" @current-change="groupTableCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                                :current-page="groupQueryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="groupQueryParams.pageSize" :total="groupTotalCount" class="pagination">    
                            </el-pagination>
                        </div>
                        <div v-show="modifyFlag"> 
                            <div class="paneContainer">
                                <div class="titleDiv">
                                    <h1 class="headerTitle">修改考生组</h1>
                                </div>
                                <div class="formDiv">
                                    <el-form :model="modfiyExamineeGroupForm">
                                        <table class="createModifyTable">
                                            <tbody>
                                                <tr>
                                                    <th>考生组名称</th>
                                                    <td>
                                                        <el-input  v-model="modfiyExamineeGroupForm.groupName"  disabled></el-input>
                                                        <el-input  v-model="modfiyExamineeGroupForm.groupId"  v-if="false"></el-input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>考生组状态</th>
                                                    <td>
                                                        <el-select v-model="modfiyExamineeGroupForm.state">
                                                            <el-option label="禁用" value="0"></el-option>
                                                            <el-option label="在用" value="1"></el-option>
                                                        </el-select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>组内人数</th>
                                                    <td><span>{{selectedExamineeTags.length+" 人"}}</span><span class="singAnswerTip">(该值自动计算，无需填写)</span></td> 
                                                </tr>
                                                <tr >
                                                    <th>组内人员</th>
                                                    <td><el-button @click="openAddExamineeDialog()" type="primary" size="small">添加考生</el-button></td> 
                                                </tr>
                                                <tr>
                                                    <th>已选考生</th>
                                                    <td> 
                                                        <div class="tagDiv">
                                                            <el-tag v-for="tag in selectedExamineeTags" :key="tag.userId" closable type="success"
                                                                :disable-transitions="false" @close="handleCloseTag(tag)">
                                                                {{tag.relayName}}
                                                            </el-tag>
                                                        </div>
                                                    </td>      
                                                </tr>
                                            </tbody>
                                        </table>
                                    </el-form>
                                    <el-button  type="success" class="submitBtn" @click="submitModifyGroup()">提 交</el-button> 
                                    <el-button  type="warning" class="submitBtn" @click="selectedExamineeTags = []">重 置</el-button>
                                    <el-button  type="info" @click="modifyFlag =false">返 回</el-button>  
                                </div>
                            </div>          
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="创建考生组" name="second">
                        <div class="paneContainer">
                            <div class="titleDiv">
                                <h1 class="headerTitle">创建考生组</h1>
                            </div>
                            <div class="formDiv">
                                <el-form :model="createGroupForm">
                                    <table class="createModifyTable">
                                        <tbody>
                                            <tr>
                                                <th>考生组名称</th>
                                                <td><el-input v-model.trim="createGroupForm.groupName" placeholder="请输入考生组名称" clearable></el-input></td>       
                                            </tr>
                                            <tr>
                                                <th>组内人数</th>
                                                <td><span>{{selectedExamineeTags.length+" 人"}}</span><span class="singAnswerTip">(该值自动计算，无需填写)</span></td>
                                            </tr>
                                            <tr>
                                                <th>组内人员</th>
                                                <td><el-button @click="openAddExamineeDialog()" type="primary" size="small">添加考生</el-button></td>    
                                            </tr>
                                            <tr>
                                                <th >已选考生</th>
                                                <td> 
                                                    <div class="tagDiv">
                                                        <el-tag v-for="tag in selectedExamineeTags" :key="tag.userId" closable type="success"
                                                            :disable-transitions="false" @close="handleCloseTag(tag)" >
                                                            {{tag.relayName}}
                                                        </el-tag>
                                                    </div>
                                                </td>      
                                            </tr>
                                        </tbody>
                                    </table>    
                                </el-form>
                                <el-button  type="success" class="submitBtn" @click="submitCreateGroup()">提 交</el-button> 
                                <el-button  type="warning" class="submitBtn" @click="resetCreateGroupForm()">重 置</el-button>                        
                            </div> 
                        </div>
                    </el-tab-pane>      
                </el-tabs>
            </div>
        </el-card>    
        <!-- 预览考生组对话框-->
        <el-dialog width="600px" title="考生组预览" :visible.sync="previewGroupDialogVisible" append-to-body>
            <div>                  
                <table class="previewGroupTable" width="100%" :data="previewTableData">
                    <tbody>
                        <tr>
                            <th style="width:80px"><b>考生组名称</b></th>
                            <td style="padding-left:10px">{{previewTableData.groupName}}</td>
                        </tr>
                        <tr>
                            <th ><b>组内人数</b></th>
                            <td style="padding-left:10px">{{previewTableData.count}}</td>
                        </tr>
                        <tr>
                            <th ><b>组内人员</b></th>
                            <td>
                                <el-table :data="previewTableData.users" max-height="500px" :header-cell-style="{height:'10px',background:'#eef1f6',color:'#606266'}">
                                    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                                    <el-table-column  label="用户名" prop="userName" align="center"></el-table-column>
                                    <el-table-column  label="真实姓名" prop="relayName" align="center"></el-table-column>              
                                </el-table>
                            </td>
                        </tr>
                    </tbody>
                </table>    
            </div>
        </el-dialog>
        <!-- 添加考生对话框-->
        <el-dialog width="600px" title="添加考生"  :visible.sync="addExamineeDialogVisible" >
            <div >                  
                <div class="dialog_search_div" >
                    <el-input v-model="examineeQueryParams.relayName" placeholder="请输入用户名称" class="impoWorldInput"></el-input>
                    <el-button @click="queryUsersByUserAndRole()" type="primary">查询</el-button>
                    <el-button @click="addSelectedExaminees()" type="warning" >批量添加</el-button>
                </div> 
                <div class="examineeTable">              
                    <el-table :data="examineesData" max-height="500px"  stripe highlight-current-row @selection-change="handleSelectionChange"
                                    :header-cell-style="{background:'#eef1f6',color:'#606266'}">  
                        <el-table-column type="selection" width="55" align="center"></el-table-column>       
                        <el-table-column prop="userName" label="用户名" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userId" label="用户ID" v-if="false"></el-table-column>
                        <el-table-column prop="relayName" label="真实姓名" align="center"></el-table-column>                            
                    </el-table>         
                </div>    
                <el-pagination @size-change="examineeTableSizeChange" @current-change="examineeTableCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                    :current-page="examineeQueryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="examineeQueryParams.pageSize" :total="examineeTotalCount" class="pagination">  
                </el-pagination>
            </div>
        </el-dialog>     
    </div>  
</template>

<script>
import {queryUsersByUserAndRole} from '../../api/user'
import {queryGroupsAndUser, createExamineeGroup, modifyExamineeGroup, deleteGroups} from '../../api/examineeGroup'
export default {
    data() {
        return {
            activeName:'first',                 //el-tab-pane首选页面，first/second
            groupTotalCount: 0,                      //总数据条数
            groupQueryParams: {
                groupId: null,
                groupName: null,
                state: '1',
                pageNum: 1,
                pageSize:10,
            }, 
            groupList: [],                      //考生组表格数据
            createGroupForm:{},                 //创建考生组表单对象
            selectedExamineeTags:[],            //创建考生组表单-已选择的考生
            addExamineeDialogVisible: false,    //添加考生对话框显示标志
            examineesData:[],                   //添加考生对话框-用户数据
            multipleTable:[],                   //添加考生对话框-选择的考生
            examineeTotalCount:0,               //添加考生对话框-总数据条数
            examineeQueryParams:{
                relayName: '',                  //添加考生对话框-搜索关键字
                roleCode: 'student',
                pageNum: 1,
                pageSize:10,
            },
            previewGroupDialogVisible: false,   //预览考生组信息对话框显示标志
            previewTableData:{},                //预览考生组信息数据
            modifyFlag:false,                   //管理界面修改界面-切换
            modfiyExamineeGroupForm:{},         //修改考生组表单对象
            multipleSelection:[],
            switchValue:true                    //禁用开关
        };
    },
    created(){
        this.queryGroupInfos();
    },
    watch:{
        switchValue: function(newSwitchValue, oldSwitchValue){
            if(newSwitchValue === true){
                this.groupQueryParams.state = '1';
            }else {
                this.groupQueryParams.state = '0';
            }
            this.queryGroupInfos();
        },
        modifyFlag:function(newSwitchValue, oldSwitchValue){
            if(newSwitchValue === false && this.activeName == 'second'){
                this.selectedExamineeTags = [];
            }
        },
    },
    methods: {
        //查询考生组信息
        queryGroupInfos(){
            queryGroupsAndUser(this.groupQueryParams).then(res => {
                //console.log(res);
                if(res.data.code === 200) {
                    this.groupList = res.data.rows;
                    this.groupTotalCount = res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });  
                    
                }
            })
        },
        //批量选择
        selectedGroupChange(val) {
            this.multipleSelection = val;
        },
        //批量删除
        deleteSelectedGroups(){
            if(this.multipleSelection.length <= 0){
                this.sendMsg("您未选择任何考生组，无法删除！", "warning");
                return
            }
            let groupIds= [];
            this.multipleSelection.forEach(item => {
                groupIds.push(item.groupId);
            })
            this.$confirm("此操作将永久删除所选考生组, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteGroups(groupIds).then(res => {
                    //console.log(res);
                    if (res.data.code === 200) {
                        this.sendMsg("删除成功", "success");
                        this.queryGroupInfos();
                    }else {
                        this.sendMsg(res.data.msg, "error");
                    }
                })
            });
        },
        //考生组表格-改变当前页码查询
        groupTableCurrentChange(val) {
            this.groupQueryParams.pageNum = val;
            this.queryGroupInfos();
        },
        //考生组表格-改变当前记录条数查询
        groupTableSizeChange(val) {
            this.groupQueryParams.pageSize = val;
            this.groupQueryParams.pageNum = 1;
            this.queryGroupInfos();
        },
        //打开添加考生对话框
        openAddExamineeDialog(){
            this.addExamineeDialogVisible = true;
            //查询所有考生
            this.examineeQueryParams.relayName = '';
            this.queryUsersByUserAndRole();
        },
        //分页查询考生 
        queryUsersByUserAndRole(){
            queryUsersByUserAndRole(this.examineeQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.examineesData = res.data.rows;
                    this.examineeTotalCount = res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },       
        //考生表格-改变当前记录条数查询
        examineeTableSizeChange(val){
            this.examineeQueryParams.pageSize = val;
            this.examineeQueryParams.pageNum = 1;
            this.queryUsersByUserAndRole();
        },
        //考生表格-改变当前页码查询
        examineeTableCurrentChange(val) {
            this.examineeQueryParams.pageNum = val;
            this.queryUsersByUserAndRole();
        },
        //批量选择考生
        handleSelectionChange(val) {
            this.multipleTable = val;
        }, 
        //批量添加考生 
        addSelectedExaminees(){
            //判断是否选择考生 
            if(this.multipleTable.length === 0){
                this.$message({
                    message: '您未勾选任何考生，请先勾选！',
                    type: 'warning'
                });
                return
            }
            if(this.selectedExamineeTags.length === 0){
                //如果未添加任何考生，则直接赋值
                this.selectedExamineeTags = this.multipleTable;
            }else {
                let result = []
                for (let i = 0; i < this.multipleTable.length; i++) {
                    let obj = this.multipleTable[i]
                    let num = obj.userId;
                    let isExist = false
                    for (let j = 0; j < this.selectedExamineeTags.length; j++) {
                        let aj = this.selectedExamineeTags[j]
                        let n = aj.userId
                        if (n === num) {
                            isExist = true
                            break
                        }
                    }
                    if (!isExist) {
                        result.push(obj)
                    }
                }
                if(result.length != 0){
                    result.forEach((multiItem,multiIndex) => {
                        this.selectedExamineeTags.push(multiItem)
                    })
                }
            }
        },
        //移除已选考生标签
        handleCloseTag(tag) {
            this.selectedExamineeTags.splice(this.selectedExamineeTags.indexOf(tag), 1);
        },
        //提交创建考生组
        submitCreateGroup(){
            if(this.createGroupForm.groupName === '' || this.createGroupForm.groupName === undefined || this.createGroupForm.groupName === null){
                this.$message({
                    message:'考生组名称不能为空',
                    type:'error'
                })
                return
            }
            if(this.selectedExamineeTags.length === 0){
                this.$message({
                    message:'您还未选择考生，无法创建，请添加！',
                    type:'error'
                })
                return
            }
            const userIds = [];
            for(let i = 0; i< this.selectedExamineeTags.length; i++){
                userIds.push(this.selectedExamineeTags[i].userId);
            }
            this.createGroupForm.createBy = JSON.parse(this.$store.state.loginInfo).userName;
            this.createGroupForm.createName = JSON.parse(this.$store.state.loginInfo).relayName;
            this.createGroupForm.userIds = userIds;
            createExamineeGroup(JSON.stringify(this.createGroupForm)).then(res => {
                if(res.data.code === 200) {
                    this.$message({
                        message:'成功创建考生组！',
                        type:'success'
                    })
                    this.activeName = 'first';
                    this.createGroupForm = {};
                    this.selectedExamineeTags = [];
                    this.queryGroupInfos();
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })    
        },
        //重置创建考生组表单数据
        resetCreateGroupForm(){
            this.createGroupForm = {};
            this.selectedExamineeTags = [];
        },    
        //预览考生组内详情 
        previewExamineeGroup(row){
            this.previewGroupDialogVisible = true;
            //根据考生组ID查询考生组信息、组内人员
            this.previewTableData = row;
            this.previewTableData.count = row.users.length;
        },
        //修改考生组信息
        modifyExamineeGroup(row) { 
            this.modifyFlag = true
            //查询出所有部门供选择
            console.log(row);
            this.modfiyExamineeGroupForm ={
                groupId: row.groupId,
                state: row.state,
                groupName: row.groupName
            };
            this.selectedExamineeTags = row.users;
        },
        //修改考生组信息提交
        submitModifyGroup(){
            if(this.selectedExamineeTags.length === 0){
                this.$message({
                    message:'您还未选择考生，无法创建，请添加！',
                    type:'error'
                })
                return
            }
            const userIds = [];
            for(let i = 0; i< this.selectedExamineeTags.length; i++){
                userIds.push(this.selectedExamineeTags[i].userId);
            }
            this.modfiyExamineeGroupForm.createBy = JSON.parse(this.$store.state.loginInfo).userName;
            this.modfiyExamineeGroupForm.createName = JSON.parse(this.$store.state.loginInfo).relayName;
            this.modfiyExamineeGroupForm.userIds = userIds;
            modifyExamineeGroup(JSON.stringify(this.modfiyExamineeGroupForm)).then(res => {
                if(res.data.code === 200) {
                    this.$message({
                        message:'成功修改考生组！',
                        type:'success'
                    })
                    this.backToManagerExamineeGroup();
                    this.modfiyExamineeGroupForm = {};
                    this.selectedExamineeTags = [];
                    this.queryGroupInfos();
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })   
        },
        //回到管理页面
        backToManagerExamineeGroup(){
            this.modifyFlag = false
        }, 
        //删除当前考生组,走修改接口
        modifyState(row) { 
            this.modfiyExamineeGroupForm = {
                groupId: row.groupId,
                groupName: row.groupName,

            };
            const userIds = [];
            for(let i = 0; i< row.users.length; i++){
                userIds.push(row.users[i].userId);
            }
            this.modfiyExamineeGroupForm.userIds = userIds;
            if(this.switchValue === true){
                this.modfiyExamineeGroupForm.state = '0';
            }else {
                this.modfiyExamineeGroupForm.state = '1';
            }           
            console.log(this.modfiyExamineeGroupForm);           
            modifyExamineeGroup(JSON.stringify(this.modfiyExamineeGroupForm)).then(res => {
                if(res.data.code === 200) {
                    this.$message({
                        message:'成功删除考生组！',
                        type:'success'
                    })
                    this.modfiyExamineeGroupForm = {};
                    this.selectedExamineeTags = [];
                    this.queryGroupInfos();
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })   
        },
        //格式化时间格式
        dateFormatter (datetime) {
            if(datetime!= '' && datetime!= null && datetime!= undefined){
                let date = new Date(datetime)
                var year = date.getFullYear()
                var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
                var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
                var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
                // 拼接 时间格式处理
                return year + '年' + month + '月' + day + '日 ' + hours + ':' + minutes + ':' + seconds
            }else {
                return ''
            }
        },
        //报送信息模板
		sendMsg(msg, type) {
			this.$message({
				message: msg,
				type: type
			});
		}
    }
};
</script>
<style lang="less" scoped>
    .fatherCard {
        width: 1672px;
        position: fixed;
        height: 90vh;
        .list_container {
            display: flex;
            flex-direction: column;
            align-items: center;
            .search_container {
                width: 100%;
                margin-bottom: 10px;
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                .el-input {
                    width: 200px;
                }
            } 
            .el-pagination {
                margin-top: 10px;
            }
        }
    }
    .currentLocation {
        font-weight:bold
    }
    .impoWorldInput {
        margin-right: 10px;
    }
    .pagination {
        
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .paneContainer {
        border: 1.5px #E4E7ED solid;
        padding-bottom: 20px;
    }
    .titleDiv {
        background: #f5f5f5;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 10px;
        margin-bottom: 20px;
    }
    .headerTitle {
        font-size: 14px;
        color: #666;    
    }
    .formDiv {
        margin-left: 5%;
    }
    .formDiv .submitBtn {
        width: 150px;
        margin-top: 20px;
    }
    .createModifyTable {
        border-collapse: collapse;
        border: none;
    }
    .createModifyTable tr {
        height:50px
    }
    .createModifyTable th {
        color: #666;
        text-align: right;
        vertical-align: center;
        font-size: 12px;
    }
    .createModifyTable td {
        width: 780px;
        padding-left: 10px;
    }
    .tagDiv {
        height: 280px;
        border: 1px #E4E7ED solid;
        border-radius: 5px;
        vertical-align: top;
    }
    .dialog_header {
        width: 600px;
        height: 50px;
        margin-top: -20px;
        margin-left: -20px;
        background-color: #F8F8F8;
        padding-top: 15px;
        padding-left: 15px;
    }
    .examineeTable {
        width: 100%;
        margin-bottom: 20px;
    }
    
    .previewGroupTable {
        border-collapse: collapse;
        border: solid 1px #eee;
    }
    .previewGroupTable tbody {
        color: #000;
    }
    .previewGroupTable th {
        font-weight: normal;
        text-align: right;
        font-size: 12px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 25px;
        padding: 8px 8px !important;
    }
    .singAnswerTip {
        margin-left: 10px;
        font-size: 12px;
        color: #909399;
    }
    .dialog_search_div {
        display: flex; 
        margin-bottom: 20px;       
    }
    .switchDiv {
        display: flex;
        flex-flow: column;
        align-items: center;
    }
</style>
